import { createGenericFormSlice, SliceState } from "./genericFormSlice";
import { GuestStatus } from "../types";

export interface MinimalGuest {
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  status: GuestStatus;
}

const formSlice = createGenericFormSlice({
  name: "createVent",
  initialState: {} as SliceState<MinimalGuest>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createGuestReducer = formSlice.reducer;
export default createGuestReducer;
